import { render } from "./DoDont.vue?vue&type=template&id=d8447c22"
import script from "./DoDont.vue?vue&type=script&lang=js"
export * from "./DoDont.vue?vue&type=script&lang=js"

import "./DoDont.vue?vue&type=style&index=0&id=d8447c22&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__